<template>
  <v-tabs
    class="mx-auto"
    v-model="currentTab"
    density="default"
    id="tabs-panel"
  >
    <template
      v-for="menuItem in menu"
      :key="menuItem.path"
    >
      <v-tab
        v-if="!menuItem.expandable && !menuItem.children"
        :value="menuItem.path"
        :exact="hasChildTabs(menuItem.path)"
        v-bind="bindLinks(menuItem)"
        @click="scrollContentTop()"
      >
        <template
          #prepend
          v-if="menuItem.icon"
        >
          <!--          #2949ff #2eab90 teal-accent-4 cyan-accent-4 green-accent-3 -->
          <v-icon
            class="mr-n1"
            :class="menuItem.iconClass||''"
            size="24"
          >
            {{ menuItem.icon }}
          </v-icon>
        </template>
        {{ menuItem.name }}
      </v-tab>
      <v-menu
        v-else
        open-on-click
        open-on-focus
      >
        <template v-slot:activator="{ props }">
          <v-tab
            v-bind="props"
            :value="menuItem.path"
            @click.prevent.capture
            :to="menuItem.path"
          >
            {{ menuItem.name }}
            <v-icon
              icon="mdi-menu-down"
              end
            ></v-icon>
          </v-tab>
        </template>
        <v-list>
          <v-list-item
            v-for="subMenuItem in menuItem.children"
            v-bind="bindLinks(subMenuItem)"
            :key="subMenuItem.path"
          >
            {{ subMenuItem.name }}
          </v-list-item>
        </v-list>
      </v-menu>

    </template>
  </v-tabs>
</template>

<script
  setup
  lang="ts"
>

import type { MenuItem } from '~~/shared/services/menu/MenuItem';
import { bindLinks, scrollContentTop } from '~~/shared/services/menu/MenuService';

const props = defineProps<{
  menu: MenuItem[];
}>();

// Selected from the route already on the server: otherwise the tab underline appears only after
// hydration and the bar visibly changes on load.
const route = useRoute();
const currentTab = ref<string | null>(activeTabPath(props.menu, route.path));
watch(() => route.path, (path) => {
  currentTab.value = activeTabPath(props.menu, path);
});

/** A tab whose path is a parent of another tab is active only on its own page, not on the child tab pages. */
function hasChildTabs(tabPath: string): boolean {
  return props.menu.some(item => item.path.startsWith(`${tabPath}/`));
}

/** The deepest tab whose path is the current path or its parent. */
function activeTabPath(menu: MenuItem[], path: string): string | null {
  const matches = menu
    .map(item => item.path)
    .filter(tabPath => !tabPath.startsWith('http') && (path === tabPath || path.startsWith(`${tabPath}/`)));
  return matches.sort((a, b) => b.length - a.length)[0] ?? null;
}

</script>
